import { HomepageVideo } from "types/working-model";
import { isObject } from "underscore";

export const isHomepageVideo = (video: unknown): video is HomepageVideo => {
	return isObject(video) && "type" in video && typeof video.video === "number";
};